<template>
  <div class="content-area bg-white">
    <vs-navbar
      class="navbar-custom navbar-skelton"
      :color="''"
      type="fund"
      text-color="#FFFFFF"
      active-text-color=""
    >
      <div tag="div" class="vx-logo cursor-pointer mr-auto flex items-center">
        <img
          :src="appSettings.logo.full_path"
          alt="logo"
          class="logo-img mr-4"
          v-if="appSettings && appSettings.logo ? true : false"
        />
      </div>
    </vs-navbar>

    <div class="content-wrapper-login">
      <div class="tabs-section mb-6">
        <span
          @click="setupLevel(levels.otd_login)"
          class="title mr-4"
          :class="
            level == levels.otd_login ? 'title_active_otd' : 'title_inactive'
          "
          >OTD</span
        >
        <span
          @click="setupLevel(levels.aa_login)"
          class="title"
          :class="
            level !== levels.otd_login ? 'title_active_aa' : 'title_inactive'
          "
          >Agent Academy</span
        >
      </div>
      <div class="form-section">
        <login-video
          v-if="settings.background.id"
          :background="settings.background"
          :background_aa="settings.background_aa"
          :current_step="level"
          :register="level == levels.aa_register ? true : false"
        />
        <login-otd :isPromptActive="level == levels.otd_login ? true : false" />
        <login-entry-agent-academy
          :isPromptActive="level == levels.aa_login ? true : false"
          :callBackLogin="callBackLoginAA"
          @toggleRegisterFormPrompt="toggleRegisterFormPrompt(true)"
        />
        <login-otp
          :isPromptActive="level == levels.aa_otp ? true : false"
          :email="email"
          :phone="phone"
          @toggleRegisterFormPrompt="toggleRegisterFormPrompt(true)"
        />
        <register
          :isPromptActive="level == levels.aa_register ? true : false"
          :callBackRegister="callBackRegisterAA"
          @toggleLoginAAFormPrompt="setupLevel(levels.aa_login)"
        />
      </div>
    </div>

    <div class="footer font-bold text-dark">
      <p class="flex w-full vx-row items-center justify-center login-footer">
        @{{ new Date().getFullYear() }}
        <a
          class="ml-5 text-dark font-bold"
          target="_blank"
          href="https://www.mtn.bj/"
          >MTN BENIN</a
        >
      </p>
    </div>
  </div>
</template>

<script>
import LoginEntryAgentAcademy from "./AgentAcademy/LoginEntryAgentAcademy.vue";
import LoginOtp from "./AgentAcademy/LoginOtp.vue";
import LoginOtd from "./LoginOtd.vue";
import LoginVideo from "./LoginVideo.vue";
import Register from "./register.vue";

export default {
  name: "Login",
  components: {
    LoginOtd,
    LoginEntryAgentAcademy,
    LoginOtp,
    LoginVideo,
    Register,
  },
  data() {
    return {
      settings: {
        logo: {
          full_path: "",
        },
        background: {
          full_path: "",
        },
        background_aa: {
          full_path: "",
        },
      },
      levels: {
        aa_login: "1",
        otd_login: "2",
        aa_otp: "3",
        aa_register: "4",
      },
      level: null,
      email: "",
      phone: null,
    };
  },
  watch: {
    level: function (value) {
      localStorage.setItem("auth_step", value);
    },
  },
  computed: {
    navBarVLogoText() {
      return {
        "font-weight": "bold",
        "font-size": "14px",
        color: "#000000",
      };
    },
    appSettings() {
      return JSON.parse(localStorage.getItem("settings"));
    },
  },
  methods: {
    async getSettings() {
      this.$vs.loading();
      try {
        let response = await this.$http("/settings");
        if (response) {
          this.settings = response.data;
          localStorage.setItem("settings", JSON.stringify(this.settings));
        }
        this.$vs.loading.close();
      } catch (error) {
        this.$vs.loading.close();
        console.log(error);
      }
    },
    setupLevel(new_level) {
      this.level = new_level;
    },
    toggleRegisterFormPrompt() {
      this.setupLevel(this.levels.aa_register);
    },
    callBackRegisterAA({ status, email, phone }) {
      if (status == true) {
        this.email = email;
        this.phone = phone;
        this.setupLevel(this.levels.aa_otp);
        localStorage.setItem("auth_step", this.level);
      }
    },
    async getSettings() {
      this.$vs.loading();
      try {
        let response = await this.$http("/settings");
        if (response) {
          this.settings = response.data;
          localStorage.setItem("settings", JSON.stringify(this.settings));
        }
        this.$vs.loading.close();
      } catch (error) {
        this.$vs.loading.close();
        console.log(error);
      }
    },
    callBackLoginAA({ status, email, phone }) {
      if (status == true) {
        this.email = email;
        this.phone = phone;
        this.setupLevel(this.levels.aa_otp);
        localStorage.setItem("auth_step", this.level);
      }
    },
  },
  mounted() {
    let level = localStorage.getItem("auth_step");
    if (level) {
      this.level = level;
    } else {
      this.setupLevel(this.levels.otd_login);
    }
    this.getSettings();
  },
};
</script>

<style lang="scss">
* {
  box-sizing: border-box;
}

body {
  margin: 0;
}

.content-wrapper-login {
  min-height: calc(100vh - 9.5rem);
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  margin-left: 19%;
  margin-right: 12%;
  justify-content: center;
  // border: 1px solid black;
}

.form-section {
  width: 100%;

  .form {
    max-width: 30% !important;
    height: auto;
    // margin-top: 8%;
    margin-bottom: 10%;
    background: rgba(196, 196, 196, 0.5);
    backdrop-filter: blur(4px);

    /* Note: backdrop-filter has minimal browser support */
    border-radius: 0px 30px 30px 0px;
    width: 30% !important;
    float: left;
    padding-left: 1rem;
    padding-right: 1rem;
    padding-bottom: 1.5rem;
    padding-top: 0.5rem;

    .form_title {
      font-size: 14px;
      line-height: 28px;
      color: #000000;
      font-weight: bold;
    }
    .form_subtitle {
      font-size: 13px;
      line-height: 19px;
      color: #000000;
      .yello_word {
        font-weight: bold;
        font-style: italic;
      }
    }
    .form_field {
      padding-top: 2.5rem;
      padding-bottom: 2rem;
    }

    label {
      font-weight: 400;
      font-size: 12px;
      color: #212529;
    }
  }

  .agent_number {
    color: #d3a901;
    font-weight: bold;
  }
}

@media (min-width: 1030px) {
  .form-section .form {
    max-width: 50% !important;
    width: 38% !important;
    // background: blue;
  }
}

@media (max-width: 1030px) {
  .form-section .form {
    max-width: 50% !important;
    width: 40% !important;
    // background-color: red;
  }

  .digit-box {
    height: 32px;
    width: 30px;
  }
}

@media (max-width: 1000px) {
  .form-section .form {
    max-width: 50% !important;
    width: 40% !important;
    // background-color: red;
  }

  .digit-box {
    height: 32px;
    width: 30px;
  }
}

@media (max-width: 878px) {
  .form-section .form {
    max-width: 40% !important;
    width: 40% !important;
    // background-color: red;

    .digit-box {
      height: 32px;
      width: 29px;
    }
  }
}

@media (max-width: 800px) {
  .form-section .form {
    width: 50% !important;
  }
}

.link_auth {
  font-weight: 400;
  font-size: 14.5px;
  line-height: 21px;
  text-decoration-line: underline;
  color: rgba(33, 37, 41, 0.7);
  cursor: pointer;
}

.link_resend_otp {
  font-weight: 400;
  font-size: 11px;
  line-height: 21px;
  text-decoration-line: underline;
  color: rgba(33, 37, 41, 0.7);
  cursor: pointer;
}

/* Create three equal columns that floats next to each other */
.column {
  float: left;
  width: 50%;
  padding: 15px;
}

.actions {
  margin-left: 24px;
}

/* Clear floats after the columns */
.content-wrapper-login:after {
  content: "";
  display: table;
  clear: both;
}

/* Responsive layout - makes the three columns stack on top of each other instead of next to each other */
@media screen and (max-width: 600px) {
  .column {
    width: 100%;
  }
}

/* Style the footer */
.footer {
  justify-content: space-between !important;
  flex-wrap: wrap !important;
  padding: 1rem 2.2rem;
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 12px;
}

.logo-img {
  width: 85px;
}

.tabs-section {
  height: 26px;
  width: 100%;
  // border: 1px solid black;
  .title {
    font-weight: bold;
    cursor: pointer;
  }

  .title_active_otd {
    font-size: 20px;
    line-height: 15px;
    color: #000000;
    font-weight: bold;
    border-bottom: 5px solid #0c557d;
  }
  .title_active_aa {
    font-size: 20px;
    line-height: 15px;
    color: #000000;
    font-weight: bold;
    border-bottom: 5px solid #ffcc00;
  }

  .title_inactive {
    font-size: 17px;
    line-height: 1px;
    color: grey;
    font-weight: bold;
  }
}
</style>